<div class="programs-container gap flex flex-row justify-between items-center">
  <button
    mat-stroked-button
    color="primary"
    gtm="onOpen"
    gtmAction="Multiple days selection dialog"
    gtmCategory="waterSchedule"
    id="edit-multiple-dhw-btn"
    data-at-edit-multiple
    (click)="timemanagerDialogService.openSelectDaysDialog()"
  >
    {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
  </button>
  <div data-at-programs class="programs flex flex-row gap-[50px]">
    <app-program-toggle-panel
      *ngIf="activeTabIndex === 0"
      [circuitId]="circuitId"
    ></app-program-toggle-panel>
    <ng-container *ngIf="activeTabIndex !== 0">
      <vi-program-item
        *ngFor="let program of scheduleService.programs$ | async"
        [program]="program.css"
        [hasTemperature]="false"
      >
        <vi-text name class="flex-1">
          {{ program?.name | translateOperatingProgram }}
        </vi-text>
      </vi-program-item>
    </ng-container>
  </div>
</div>
